import { useEffect, useState } from "react";
import { Menu, Spin } from "antd";
import { 
    AppstoreOutlined, 
    HomeOutlined, 
    PlusSquareOutlined, 
    StarOutlined, 
    UnorderedListOutlined, 
    ApartmentOutlined, 
    ClusterOutlined, 
    IdcardOutlined, 
    TagsOutlined, 
    TeamOutlined, 
    BankOutlined, 
    AuditOutlined,
    OrderedListOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./sideMenuAdmin.css";
import { getFromLocalStorage } from "../../helpers/EncryptData";
import {  } from "@ant-design/icons";
import axios from "axios";
import { apiUrl } from '../../utility/Connections';

const { SubMenu } = Menu;

const SideMenuAdmin = (props) => {
    const [orgData, setOrgData] = useState(null);
    const [orgServices, setOrgServices] = useState(null);
    const [current, setCurrent] = useState("create");
    const [openKeys, setOpenKeys] = useState([]); 
    const [showLoading, setShowLoading] = useState(false);
    const navigate = useNavigate();

    const menuItemsByService = {
        1: [
            { key: "modulo-competencias/competencias", label: "Competencias", icon: <StarOutlined /> },
            { key: "modulo-competencias/evaluaciones", label: "Evaluaciones", icon: <AuditOutlined /> }
        ],
        2: [
            { key: "modulo-liderazgo/atributos-lider", label: "Atributos del Líder", icon: <StarOutlined /> },
            { key: "modulo-liderazgo/evaluaciones", label: "Evaluaciones", icon: <AuditOutlined /> }
        ],
        3: [
            { key: "3-option1", label: "Análisis de Datos" },
            { key: "3-option2", label: "Reportes de Ventas" }
        ]
    };

    const handleClick = (e) => {
        setCurrent(e.key);
        navigate(e.key);
    };

    const handleOpenChange = (keys) => {
        setOpenKeys(keys.length ? [keys[keys.length - 1]] : []);
    };

    useEffect(() => {
        if (props.showOrganizationMenu) {
            const current_org = getFromLocalStorage("current_org");
            if (current_org) {
                setOrgData(current_org);
        
                setShowLoading(true);
                const token = localStorage.getItem('access_token');
                const headers = {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                }
        
                axios.get(`${apiUrl}/rel-org-srv/get-rel-org-srv-by-org-id/${current_org.org_id}/`, headers)
                    .then(function (response) {
                        setOrgServices(response.data.services);
                        setShowLoading(false);
                    })
                    .catch(function (error) {
                        console.error('There was an error!', error);
                    });
            }
        }
    }, [props.showOrganizationMenu]); 

    return (
        <Menu
            onClick={handleClick}
            selectedKeys={[current]}
            mode="inline"
            className="sideMenuAdmin"
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
        >
            {/* Menú para SuperAdmin */}
            {props.isSuperAdmin && (
                <>
                    <Menu.ItemGroup key="group0" title="Configuración" />
                    <Menu.Item key="servicios" icon={<AppstoreOutlined />}>
                        Servicios
                    </Menu.Item>
                    <Menu.ItemGroup key="group1" title="Organizaciones" />
                    <Menu.Item key="organizaciones/crear" icon={<PlusSquareOutlined />}>
                        Crear Organización
                    </Menu.Item>
                    <Menu.Item key="organizaciones/lista" icon={<UnorderedListOutlined />}>
                        Listado de Organizaciones
                    </Menu.Item>
                    <Menu.ItemGroup key="group2" title="Evaluaciones" />
                    <Menu.Item key="evaluaciones/respuestas" icon={<OrderedListOutlined />}>
                        Opciones de Respuesta
                    </Menu.Item>
                </>
            )}

            {props.showOrganizationMenu && (props.isAdmin || props.isSuperAdmin) && orgData && (
                <Menu.ItemGroup key="group3" title={orgData.org_name} />
            )}

            {/* Menú de Organización (Colapsable) */}
            {props.showOrganizationMenu && (props.isAdmin || props.isSuperAdmin) && orgData && (
                <>
                    <SubMenu key="organizationMenu" title="Información General">
                        <Menu.Item key="organizacion/info" icon={<BankOutlined />}>
                            Organización
                        </Menu.Item>
                        <Menu.Item key="organizacion/sedes" icon={<HomeOutlined />}>
                            Sedes
                        </Menu.Item>
                        <Menu.Item key="organizacion/gerencias" icon={<ApartmentOutlined />}>
                            Gerencias
                        </Menu.Item>
                        <Menu.Item key="organizacion/areas" icon={<ClusterOutlined />}>
                            Áreas
                        </Menu.Item>
                        <Menu.Item key="organizacion/cargos" icon={<IdcardOutlined />}>
                            Cargos
                        </Menu.Item>
                        <Menu.Item key="organizacion/categorias-cargos" icon={<TagsOutlined />}>
                            Categorías de cargo
                        </Menu.Item>
                        <Menu.Item key="organizacion/colaboradores" icon={<TeamOutlined />}>
                            Colaboradores
                        </Menu.Item>
                    </SubMenu>
                    {showLoading ? (
                        <Menu.Item key="loading" disabled>
                            <Spin size="small" style={{ marginRight: 8 }} />
                            Cargando módulos...
                        </Menu.Item>
                    ) : (
                        orgServices
                            .filter(service => service.ros_active) // ✅ Solo servicios activos
                            .map(service => (
                                <SubMenu
                                    key={service.srv_id}
                                    title={service.srv_service}
                                >
                                    {menuItemsByService[service.srv_id] ? (
                                        // ✅ Renderiza los `Menu.Item` específicos del servicio
                                        menuItemsByService[service.srv_id].map(item => (
                                            <Menu.Item key={item.key} icon={item.icon}>{item.label}</Menu.Item>
                                        ))
                                    ) : (
                                        // ✅ Si no hay items específicos, mostrar un `Menu.Item` por defecto
                                        <Menu.Item key={`${service.srv_id}-default`}>
                                            No hay módulos disponibles
                                        </Menu.Item>
                                    )}
                                </SubMenu>
                            ))
                    )}
                    {/* <SubMenu key="evaluacionCompetenciasMenu" title="Evaluación Competencias">
                        <Menu.Item key="organizacion/info" icon={<BankOutlined />}>
                            Organización
                        </Menu.Item>
                    </SubMenu> */}
                </>
            )}
        </Menu>
    );
};

export default SideMenuAdmin;
